module.exports = __webpack_public_path__ + "img/twoRed.178fbae5.jpg";